import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaStar, FaQuoteLeft, FaCheckCircle } from "react-icons/fa";
import {
  SectionContainer,
  SectionContent,
  SectionHeader,
  SectionPreTitle,
  SectionSubTitle,
  SectionTitle,
} from "../../styles/global.syles";
import {
  LotterDisplayContent,
  TestimonialCard,
  TestimonialGrid,
} from "./index.styles";

const customerReviews = [
  {
    name: "Sam K.",
    store: "Valero Food Mart",
    location: "Houston, TX",
    quote:
      "Our lottery sales surged by over 40% within the first 60 days. Customers love seeing all the scratchers and live jackpots on the 4K TV, and our counter is completely clear.",
    rating: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F1.jpeg?alt=media&token=af925e05-10d9-474c-804c-30f20beaa1eb",
  },
  {
    name: "Ali R.",
    store: "Chevron Fast Stop",
    location: "San Antonio, TX",
    quote:
      "The 4K digital scratcher board stopped customer confusion immediately. Cashiers spend less time answering ticket questions and more time ringing up high-margin drinks and snacks.",
    rating: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F2.jpeg?alt=media&token=4f2c1ff7-1b8f-4f29-8e90-52b62bef6173",
  },
  {
    name: "Dave M.",
    store: "Shell Convenience Store",
    location: "Austin, TX",
    quote:
      "Beyond Lottery installed everything in one afternoon. Their full package with text-overlay CCTV and canopy LED lights made our entire store look ultra-modern.",
    rating: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F3.jpeg?alt=media&token=dc559ca0-ea84-4d5f-a2a1-f7fbe0deb57f",
  },
  {
    name: "Marcus T.",
    store: "Exxon & Deli Stop",
    location: "Dallas-Fort Worth, TX",
    quote:
      "Having our deli menu and lottery tickets running on synchronized screens transformed our store presentation. Best investment we made this year.",
    rating: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F4.jpeg?alt=media&token=b0f874cf-d0a5-437e-be26-878d74f5c29e",
  },
];

const Testimonials = () => {
  return (
    <SectionContainer id="testimonials" bg="#ffffff">
      <SectionContent>
        {/* Section header */}
        <SectionHeader>
          <SectionPreTitle>Store Owner Proof</SectionPreTitle>
          <SectionTitle>Trusted by Over 1,000+ C-Stores & Gas Stations</SectionTitle>
          <SectionSubTitle>
            See how independent operators and major franchise owners across Texas
            and nationwide increased lottery revenue and freed up checkout counter space.
          </SectionSubTitle>
        </SectionHeader>

        {/* Reviews Carousel */}
        <LotterDisplayContent>
          <Carousel
            showArrows={true}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={6000}
            showStatus={false}
            className="carousel_radius"
          >
            {customerReviews.map((rev, index) => (
              <TestimonialCard key={index}>
                <div className="review-photo-col">
                  <img
                    src={rev.img}
                    alt={`${rev.store} owner`}
                    loading="lazy"
                  />
                  <div className="verified-badge">
                    <FaCheckCircle /> Verified C-Store Partner
                  </div>
                </div>

                <div className="review-content-col">
                  <div className="stars-row">
                    {[...Array(rev.rating)].map((_, i) => (
                      <FaStar key={i} className="star-icon" />
                    ))}
                    <span className="rating-label">5.0 Star Experience</span>
                  </div>

                  <div className="quote-body">
                    <FaQuoteLeft className="quote-mark" />
                    <p>"{rev.quote}"</p>
                  </div>

                  <div className="author-info">
                    <h4 className="author-name">{rev.name}</h4>
                    <p className="store-name">
                      {rev.store} &bull; <span className="location">{rev.location}</span>
                    </p>
                  </div>
                </div>
              </TestimonialCard>
            ))}
          </Carousel>
        </LotterDisplayContent>
      </SectionContent>
    </SectionContainer>
  );
};

export default Testimonials;

let arr = [
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F1.jpeg?alt=media&token=af925e05-10d9-474c-804c-30f20beaa1eb",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F2.jpeg?alt=media&token=4f2c1ff7-1b8f-4f29-8e90-52b62bef6173",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F3.jpeg?alt=media&token=dc559ca0-ea84-4d5f-a2a1-f7fbe0deb57f",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F4.jpeg?alt=media&token=b0f874cf-d0a5-437e-be26-878d74f5c29e",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F5.jpeg?alt=media&token=424adfb7-640a-48e8-96df-6352d22dbf9e",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F6.jpeg?alt=media&token=5aeabc67-95a2-4afe-ab54-42cae0767cc5",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F7.jpeg?alt=media&token=1a90c088-f4b5-40c1-bdc1-8829d58ef930",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F8.jpeg?alt=media&token=9a6dc22a-2ded-4230-91fb-c250a6a94989",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F9.jpeg?alt=media&token=6fd25b48-6cf3-480a-aab4-90847b9958cd",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F10.jpeg?alt=media&token=7364c91b-825c-4fad-b4e6-21490cc1df4c",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F11.jpeg?alt=media&token=05f41417-221a-42d1-9b08-cb95224e3c1f",
  "https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2F12.jpeg?alt=media&token=03a37097-fbfd-49b2-b31a-16ed361e9e92",
];
